export const DEFAULT_RETAILERS_IDS = [949, 22865, 989, 132, 1623];

export const MAX_RETAILERS_PER_PAGE = 8;
